import React from 'react';
import {Helmet} from 'react-helmet';

function LayoutLogin({ children }) {
    return (
      <>
        <Helmet>
		      <title>Top Pymes - Login</title>
        </Helmet>
        {/* Resto de tu layout */}
        {children}
      </>
    );
  }
  
  export default LayoutLogin;